<p-accordion>
    <p-accordionTab header="Municipal" >
        <app-lista-arquivos [miniMode]="true" categoria="cdebmunic"></app-lista-arquivos>
    </p-accordionTab>
    <p-accordionTab header="Estado" >
        <app-lista-arquivos [miniMode]="true" categoria="cdebfazenda"></app-lista-arquivos>
    </p-accordionTab>
    <p-accordionTab header="Federal" >
        <app-lista-arquivos [miniMode]="true" categoria="certidaoUniao"></app-lista-arquivos>
    </p-accordionTab>
    <p-accordionTab header="FGTS" >
        <app-lista-arquivos [miniMode]="true" categoria="certidaoRegularidade"></app-lista-arquivos>
    </p-accordionTab>
</p-accordion>



